<template>
  <v-dialog
    id="cookie-consent-dialog"
    :value="show"
    :width="500"
    persistent>
    <v-card>
      <v-card-title class="font-weight-bold">
        Cookie Settings
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="$emit('change', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-5 py-4">
        <span class="text-body-2">ท่านสามารถปรับแต่งการใช้งานคุกกี้ได้ตามรายละเอียดต่อไปนี้</span>

        <v-divider class="my-4" />

        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Strictly Necessary Cookies
            </v-list-item-title>
            <v-list-item-subtitle>คุกกี้ที่จำเป็นสำหรับการทำงานของเว็บไซต์</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-switch
              v-model="isNecessary"
              input-value="true"
              inset
              disabled />
          </v-list-item-action>
        </v-list-item>
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Performance Cookies
            </v-list-item-title>
            <v-list-item-subtitle>คุกกี้ด้านประสิทธิภาพการทำงานของเว็บไซต์</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-switch
              v-model="isPerformance"
              input-value="true"
              inset />
          </v-list-item-action>
        </v-list-item>
        <v-list-item class="pa-0">
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              Advertising Cookies
            </v-list-item-title>
            <v-list-item-subtitle>คุกกี้เพื่อการโฆษณา</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-switch
              v-model="isAdvertising"
              input-value="true"
              inset />
          </v-list-item-action>
        </v-list-item>

        <v-divider class="my-4" />

        <p class="text-body-2">
          ข้อมูลที่ได้และใช้ประมวลผลจากการใช้คุกกี้นั้น ไม่มีการระบุชื่อ หรือบ่งบอกความ
          เป็นตัวตนของท่านได้ อีกทั้งไม่มีการเก็บข้อมูลจำเพาะบุคคล เช่น ชื่อ อีเมล เป็นต้น
          และใช้เป็นข้อมูลทางสถิติเท่านั้น
        </p>
        <span
          class="primary--text font-weight-bold link-text"
          @click="openPageCookiePolicy">
          นโยบายเกี่ยวกับคุกกี้ (Cookies Policy)
        </span>

        <v-row
          justify="center"
          class="pt-7">
          <v-col
            cols="6"
            sm="5">
            <v-btn
              color="primary"
              block
              large
              outlined
              class="text-body-1"
              @click="acceptAll">
              ยอมรับทั้งหมด
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            sm="5">
            <v-btn
              color="primary"
              block
              large
              class="text-body-1"
              @click="acceptSelect">
              บันทึกข้อมูล
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import {
  startAllCookies,
  startGoogleAnalaytics,
  stopGoogleAnalaytics,
  setAcceptedCookie,
  NECESSARY_COOKIE,
  PERFORMANCE_COOKIE,
  ADVERTISING_COOKIE
} from '@/utils/cookieConsent'

export default {
  name: 'CookieConsentDialog',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isNecessary: true,
      isPerformance: false,
      isAdvertising: false
    }
  },
  computed: {
    ...mapState('User', ['userProfile']),
    ...mapState('CookieConsent', ['performance', 'advertising'])
  },
  mounted() {
    this.isPerformance = this.performance
    this.isAdvertising = this.advertising
  },
  methods: {
    ...mapActions({
      setAcceptAll: 'CookieConsent/setAcceptAll',
      setAcceptPerformance: 'CookieConsent/setAcceptPerformance',
      setAcceptAdvertising: 'CookieConsent/setAcceptAdvertising'
    }),
    ...mapWaitingActions('CookieConsent', {
      setAcceptAll: 'app loading',
      setAcceptPerformance: 'app loading',
      setAcceptAdvertising: 'app loading'
    }),
    openPageCookiePolicy() {
      const routeData = this.$router.resolve({ name: 'CookiePolicy' })
      window.open(routeData.href, '_blank')
    },
    async acceptSelect() {
      await this.setAcceptPerformance(this.isPerformance)
      await this.setAcceptAdvertising(this.isAdvertising)

      if (this.isPerformance) {
        if (this.$gtm) {
          this.$gtm.enable(true)
        }
        startGoogleAnalaytics(this.$gtag)
      } else {
        stopGoogleAnalaytics(this.$gtag)
        if (this.$gtm) {
          this.$gtm.enable(false)
        }
      }

      setAcceptedCookie({
        user: this.userProfile,
        purposes: {
          [NECESSARY_COOKIE]: true,
          [PERFORMANCE_COOKIE]: this.isPerformance,
          [ADVERTISING_COOKIE]: this.isAdvertising
        },
        cookies: this.$cookies
      })

      this.$emit('change', false)
    },
    async acceptAll() {
      await this.setAcceptAll()
      if (this.$gtm) {
        this.$gtm.enable(true)
      }

      startAllCookies({
        gtag: this.$gtag
      })

      setAcceptedCookie({
        user: this.userProfile,
        purposes: {
          [NECESSARY_COOKIE]: true,
          [PERFORMANCE_COOKIE]: true,
          [ADVERTISING_COOKIE]: true
        },
        cookies: this.$cookies
      })

      this.$emit('change', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-list-item__title {
  font-size: 20px;
}

::v-deep .link-text {
  cursor: pointer;
}
</style>
